<template>
  <div class="top">
    <div class="container">
      <div class="title-wrapper">
        <span class="title">Circles you’ve joined</span>
      </div>
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">Your circles will be displayed here.</span>
          <span class="sub-dailog">Please log in to view your circles or create an account to join a circle.</span>
          <button class="get-started-btn" @click="goToSSO">Get Started</button>
          <!-- <SSOModal ref="modal" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.top {
  width: 100%;
}
.get-started-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 121px;
  height: 48px;
  background: #062b54;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: #ffffff;
  border: none;
}

.sub-dailog {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #33415f;
}

.dailog {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}
.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  text-align: center;
}
.title-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  width: 100%;
  @media only screen and (max-width: 710px) {
    align-items: center;
  }
}
.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  width: 100%;
  height: 229px;
}
</style>

<script>
import SSOLogin from "../../login/login-register-component.vue"
import SSOModal from "../../login/login-register-modal.vue"
export default {
  name: "UnAuthCircle",
  components: {
    SSOLogin,
    SSOModal,
  },
  created() {
    console.warn("UnAuthCircle.vue is created")
  },
  methods: {
    ssoLogin() {
      this.$refs.modal.open()
      // this.$store.commit("SsoLogin/openModal")
      // document.body.scrollTop = 0
      //   setTimeout(() => {
      //     this.$refs.modal.open()
      //   }, 1000)
    },
    goToSSO() {
      window.location.href = `${process.env.SSO_BASE_URL}/dovemed-sso?next=${process.env.SSO_BASE_URL}/mycircles`
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/App/circle/UnAuthCircle.vue